var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DCDEE1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9997 39.3346L30.4637 39.0146C32.417 37.664 35.5837 37.664 37.5357 39.0146L37.9997 39.3346M28.6663 27.3346H28.6797M39.333 27.3346H39.3463M33.9997 27.3346H34.013M33.9997 32.668H34.013M39.333 32.668H39.3463M28.6663 32.668H28.6797M31.333 47.3346V38.668M36.6663 38.668V47.3346M41.9997 20.668H25.9997C25.2924 20.668 24.6142 20.9489 24.1141 21.449C23.614 21.9491 23.333 22.6274 23.333 23.3346V44.668C23.333 45.3752 23.614 46.0535 24.1141 46.5536C24.6142 47.0537 25.2924 47.3346 25.9997 47.3346H41.9997C42.7069 47.3346 43.3852 47.0537 43.8853 46.5536C44.3854 46.0535 44.6663 45.3752 44.6663 44.668V23.3346C44.6663 22.6274 44.3854 21.9491 43.8853 21.449C43.3852 20.9489 42.7069 20.668 41.9997 20.668Z",
    stroke: "#E9353C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticket-icon.9bd1b89a3ac259870e560b219c775620.svg";
export { ForwardRef as ReactComponent };